<template>
    <div class="p5">
        <div class="d-flex justify-content-center flex-column align-items-center">
            <img src="https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/GraphicsEmpty.svg">
            <p style="font-size: 24px; width: 50%; text-align: center; color: #98A2B3;">
                <b> No hay información reflejada en las fechas seleccionadas. </b>
            </p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>